import React from 'react';
import { Typography, Divider, Stack } from '@mui/material'; // Removed Paper
import GlassCard from '../../../ui/glass/components/GlassCard';
import { formatCurrency } from '../../../utils/formatters';

const CustomerFinancialSummary = ({ financialSummary, balance }) => {
    return (
        <GlassCard sx={{ p: 2, height: '100%' }}>
            <Typography variant="h6" gutterBottom>Müşteri Cari Bilgisi</Typography>
            <Divider sx={{ mb: 2 }} />
            <Stack spacing={1}>
                <Typography><b>Toplam Ciro:</b> {formatCurrency(financialSummary.total)}</Typography>
                <Typography color="success.main"><b>Toplam Tahsilat:</b> {formatCurrency(financialSummary.paid)}</Typography>
                <Typography color={balance > 0 ? "error.main" : "inherit"} variant="h6"><b>Genel Bakiye:</b> {formatCurrency(balance)}</Typography>
            </Stack>
        </GlassCard>
    );
};

export default CustomerFinancialSummary;
